import { initialDaHomeState } from "store/initialStates";
import { ReducersInterfaceAction } from "types/Reducers";
import { DaHomeConstants } from "constants/constants";
import { DaHomeState } from "types/DaHome";

export const daHomeReducer = (
  state = initialDaHomeState,
  action: ReducersInterfaceAction,
): DaHomeState => {
  switch (action.type) {
    case DaHomeConstants.DA_HOME_GET_DATA_SUCCESS:
      return {
        ...state,
        loadingData: false,
        dataList: action.payload,
      };
    case DaHomeConstants.DA_HOME_LOADING:
      return {
        ...state,
        loadingData: true,
      };
    case DaHomeConstants.DA_HOME_ERROR:
      return {
        ...state,
        loadingData: false,
      };
    case DaHomeConstants.DA_HOME_SET_FILTERS:
      return {
        ...state,
        homeFilters: action.payload,
      };
    default:
      return state;
  }
};
